export interface Speaker {
  id: string;
  name: string;
  photo: string;
  social: {
    linkedin?: string;
  };
}

export const speakers: Speaker[] = [
  {
    id: '1',
    name: 'Abhinav Sharma',
    photo: '/images/copadospeaker/Abhinav Sharma.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/abhinavsharma04/',
    },
  },
  {
    id: '2',
    name: 'Ankita Sharma',
    photo: '/images/copadospeaker/Ankita.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/ankita-sharma-16431850/',
    },
  },
  {
    id: '3',
    name: 'Ashok Kosinepalli',
    photo: '/images/copadospeaker/Ashok.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/ashok-kosinepalli-790574152/',
    },
  },
  {
    id: '4',
    name: 'Christie Marsh',
    photo: '/images/copadospeaker/Christie.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/christiehoylemarsh/',
    },
  },
  {
    id: '5',
    name: 'David Pinett',
    photo: '/images/copadospeaker/David Pinett.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/david-pinett/',
    },
  },
  {
    id: '6',
    name: 'Dinesh Yenda',
    photo: '/images/copadospeaker/dinesh.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/dinesh-yenda-978659100/',
    },
  },
  {
    id: '7',
    name: 'Esko Hannula',
    photo: '/images/copadospeaker/Esko.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/esko-hannula-78b457/',
    },
  },
  {
    id: '8',
    name: 'Federico Larsen',
    photo: '/images/copadospeaker/federico.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/federicolarsen/',
    },
  },
  {
    id: '9',
    name: 'Gandharv Madan',
    photo: '/images/copadospeaker/Gandharv.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/%F0%9F%8E%99gandharv-madan-552891162/',
    },
  },
  {
    id: '10',
    name: 'Gaurav Kheterpal',
    photo: '/images/copadospeaker/gaurav.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/gauravkheterpal/',
    },
  },
  {
    id: '11',
    name: 'Ivan Coppola',
    photo: '/images/copadospeaker/Ivan.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/ivan-coppola-19721b15/',
    },
  },
  {
    id: '12',
    name: 'Lee Cunningham',
    photo: '/images/copadospeaker/Lee C image.jpeg',
    social: {
      linkedin: 'https://www.linkedin.com/in/lee-cunningham-53a791b3/',
    },
  },
  {
    id: '13',
    name: 'Manish Sharma',
    photo: '/images/copadospeaker/ManishSharma.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/manishsharma/',
    },
  },
  {
    id: '14',
    name: 'Navita Sharma',
    photo: '/images/copadospeaker/NavitaSharma.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/sharmanavita/',
    },
  },
  {
    id: '15',
    name: 'Nitesh Natha',
    photo: '/images/copadospeaker/Nitesh Natha.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/nitesh-natha-a93029aa/',
    },
  },
  {
    id: '16',
    name: 'Phil Rackwitz',
    photo: '/images/copadospeaker/phil.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/philipprackwitz/',
    },
  },
  {
    id: '17',
    name: 'Piyali Sanyal',
    photo: '/images/copadospeaker/piyali.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/piyali-sanyal-3378b31a1/',
    },
  },
  {
    id: '18',
    name: 'Prasad Joshi',
    photo: '/images/copadospeaker/prasad.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/prasad-joshi-aa18b87/',
    },
  },
  {
    id: '19',
    name: 'Prashanth Krishnamurthy',
    photo: '/images/copadospeaker/Pranshanth.png',
    social: {
      linkedin: 'https://www.linkedin.com/in/prashanthkrishnamurthy/',
    },
  },
  {
    id: '20',
    name: 'Rahul Kumar',
    photo: '/images/copadospeaker/rahulKumar.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/rahul-kumar-97622b150/',
    },
  },
  {
    id: '21',
    name: 'Rajan Gaur',
    photo: '/images/copadospeaker/rajan.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/rajan-gaur-42a8489/',
    },
  },
  {
    id: '22',
    name: 'Ranjith Shetty Padumundu',
    photo: '/images/copadospeaker/Ranjith Shetty.jpeg',
    social: {
      linkedin: 'https://www.linkedin.com/in/ranjithshettyp/',
    },
  },
  {
    id: '23',
    name: 'Rohit Boggarapu',
    photo: '/images/copadospeaker/Rohit Boggarapu.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/rohit-boggarapu-0252b230/',
    },
  },
  {
    id: '24',
    name: 'Sanjay Gidwani',
    photo: '/images/copadospeaker/sanjay g.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/sgidwani/',
    },
  },
  {
    id: '25',
    name: 'Shaibaaz Kalyankar',
    photo: '/images/copadospeaker/shaibaaz.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/shaibaaz-kalyankar-7aaa324/',
    },
  },
  {
    id: '26',
    name: 'Steve Simpson',
    photo: '/images/copadospeaker/steve.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/stevesimpson6/',
    },
  },
  // {
  //   id: '27',
  //   name: 'Swapnil Dongare',
  //   photo: '/images/copadospeaker/swapnil.jpg',
  //   social: {
  //     linkedin: 'https://www.linkedin.com/in/swapnil-dongare/',
  //   },
  // },
  {
    id: '28',
    name: 'Tulsi Krishnaa D',
    photo: '/images/copadospeaker/Tulsi Krishnaa D.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/tulsikrishnaad/',
    },
  },
  {
    id: '29',
    name: 'Upendra Athalye',
    photo: '/images/copadospeaker/upendra.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/uva/',
    },
  },
  {
    id: '30',
    name: 'Vaibhav Shah',
    photo: '/images/copadospeaker/vibhav.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/vaibhav-shah-33358228/',
    },
  },
  {
    id: '31',
    name: 'Vikas Khandelwal',
    photo: '/images/copadospeaker/vikas khandewal.png',
    social: {
      linkedin: 'https://www.linkedin.com/in/vikas-khandelwal-b7314b35/',
    },
  },
  {
    id: '32',
    name: 'Yeshwant Nayak',
    photo: '/images/copadospeaker/Yeshwant Nayak.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/yeshwant-nayak/',
    },
  }
];